import {
  getActivimeterDetails,
  removeActivimeterDetail,
  setActivimeterDetailFilters,
  updateActivimeterDetail,
} from '@state/reducers/activimeterDetailReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { ActivimeterDetailDto } from '@services/dtos'
import { useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { AppDispatch } from '@state/store'
import ActivimeterDetailForm from '../forms/ActivimeterDetailForm'

export default function ActivimeterDetailsTable() {
  const columns: GridColumns<ActivimeterDetailDto> = useMemo(
    () => [
      {
        field: 'equipment',
        headerName: 'Équipement',
        minWidth: 150,
        valueGetter: (params) => params.row.equipment.name,
      },
      { field: 'path', headerName: 'Chemin', minWidth: 150 },
      {
        field: 'electronicZero',
        headerName: '0 électronique (fA)',
        minWidth: 150,
        type: 'number',
      },
      {
        field: 'voltageMin',
        headerName: 'Tension min (V)',
        minWidth: 130,
        type: 'number',
      },
      {
        field: 'voltageMax',
        headerName: 'Tension max (V)',
        minWidth: 130,
        type: 'number',
      },
      {
        field: 'testWithCobalt57',
        headerName: 'Test avec Cobalt 57',
        minWidth: 160,
        type: 'boolean',
      },
      {
        field: 'testWithCesium137',
        headerName: 'Test avec Césium 137',
        minWidth: 160,
        type: 'boolean',
      },
      {
        field: 'testWithBarium133',
        headerName: 'Test avec Baryum 133',
        minWidth: 170,
        type: 'boolean',
      },
      {
        field: 'backgroundWithoutSampleHolderMbq',
        headerName: 'Fond sans porte-échantillon (MBq)',
        minWidth: 250,
        type: 'number',
      },
      {
        field: 'backgroundWithSampleHolderMbq',
        headerName: 'Fond avec porte-échantillon (MBq)',
        minWidth: 250,
        type: 'number',
      },
    ],
    [],
  )

  return (
    <BaseConfigTable<ActivimeterDetailDto>
      columns={columns}
      selectRows={(state) => state.activimeterDetail.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setActivimeterDetailFilters({ includeInactive: true }))
        return dispatch(getActivimeterDetails())
      }}
      deleteThunk={removeActivimeterDetail}
      toggleThunk={(id, isActive) =>
        updateActivimeterDetail({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setActivimeterDetailFilters({ page }))
        dispatch(getActivimeterDetails())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <ActivimeterDetailForm
          editingActivimeterDetail={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="paramétrage activimètre"
      resourcePrefix="le "
    />
  )
}
